var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 9.99998C2.08325 6.26803 2.08325 4.40205 3.24262 3.24268C4.40199 2.08331 6.26797 2.08331 9.99992 2.08331C13.7318 2.08331 15.5978 2.08331 16.7573 3.24268C17.9166 4.40205 17.9166 6.26803 17.9166 9.99998C17.9166 13.7319 17.9166 15.5979 16.7573 16.7573C15.5978 17.9166 13.7318 17.9166 9.99992 17.9166C6.26797 17.9166 4.40199 17.9166 3.24262 16.7573C2.08325 15.5979 2.08325 13.7319 2.08325 9.99998Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16659 6.24998H14.1666M6.66659 6.24998C6.66659 6.4801 6.48004 6.66665 6.24992 6.66665C6.0198 6.66665 5.83325 6.4801 5.83325 6.24998C5.83325 6.01986 6.0198 5.83331 6.24992 5.83331C6.48004 5.83331 6.66659 6.01986 6.66659 6.24998Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16659 9.99998H14.1666M6.66659 9.99998C6.66659 10.2301 6.48004 10.4166 6.24992 10.4166C6.0198 10.4166 5.83325 10.2301 5.83325 9.99998C5.83325 9.7699 6.0198 9.58331 6.24992 9.58331C6.48004 9.58331 6.66659 9.7699 6.66659 9.99998Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16659 13.75H14.1666M6.66659 13.75C6.66659 13.9801 6.48004 14.1666 6.24992 14.1666C6.0198 14.1666 5.83325 13.9801 5.83325 13.75C5.83325 13.5199 6.0198 13.3333 6.24992 13.3333C6.48004 13.3333 6.66659 13.5199 6.66659 13.75Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinApproval);
export default __webpack_public_path__ + "static/media/join-approval.f03a44efd02433dcb6dc303a7cc742b7.svg";
export { ForwardRef as ReactComponent };